/**
 * FileLink — the link for a case file, from agentUi.fileLinkProps: "Open" in a new tab (noopener)
 * for images and PDFs, "Download" (download attribute, no target) for HTML, SVG and other active
 * content, which must never be navigated to on the app origin.
 */

import { ExternalLink, Download } from 'lucide-react';

/** Open (new tab) or Download (active content), from fileLinkProps. */
export default function FileLink({ link, className = 'wbd__link', children = null }) {
  if (!link) return null;
  const Icon = link.newTab ? ExternalLink : Download;
  return link.newTab ? (
    <a href={link.href} target={link.target} rel={link.rel} className={className}>
      {children ?? link.label} <Icon size={10} aria-hidden="true" />
    </a>
  ) : (
    <a href={link.href} download={link.download} className={className}>
      {children ?? link.label} <Icon size={10} aria-hidden="true" />
    </a>
  );
}

